/**
 * useApi Hook for Authentication
 * Provides register and login functions with state management
 */

import { useState } from 'react';
import { sqlApi, RegisterData } from '../services/sql-api';

export function useAuth() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Register a new user
   */
  const register = async (userData: RegisterData): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      console.log('🚀 Starting registration process...');
      console.log('📝 Form data:', userData);
      
      const result = await sqlApi.register(userData);
      setLoading(false);
      
      if (result.success) {
        console.log('✅ Registration successful in API');
        return true;
      } else {
        setError(result.message || 'Registration failed');
        return false;
      }
    } catch (err: any) {
      console.error('❌ Registration error:', err);
      setError(err.message || 'Registration failed. Please check if backend server is running.');
      setLoading(false);
      return false;
    }
  };

  /**
   * Login user
   */
  const login = async (loginData: { email?: string; mobile?: string; password: string }): Promise<any> => {
    setLoading(true);
    setError(null);

    try {
      console.log('🚀 Starting login process in useApi...');
      const result = await sqlApi.login(loginData);
      setLoading(false);
      
      console.log('📦 useApi received result:', result);
      
      if (result.success) {
        console.log('✅ Login successful in useApi');
        return result;
      } else {
        setError(result.message || 'Login failed');
        return null;
      }
    } catch (err: any) {
      console.error('❌ useApi login error:', err);
      setError(err.message || 'Login failed. Please try again.');
      setLoading(false);
      return null;
    }
  };

  const clearError = () => setError(null);

  return {
    register,
    login,
    loading,
    error,
    clearError,
  };
}